import React from "react";
import { Link } from "react-router-dom";
import { productCategories } from "../data/siteData";
import SectionTitle from "./SectionTitle";
import Reveal from "./Reveal";
import ProductCarousel from "./ProductCarousel";

export default function ProductsSection() {
  return (
    <section id="products" className="products section">
      <div className="container">
        <SectionTitle
          label="04 — PRODUCTS"
          title={
            <>
              多様な商品を、
              <br />
              次の商機へ。
            </>
          }
          description="カテゴリーを越えた品揃えで、さまざまな業態・販売機会に対応します。"
        />
        <div className="portfolio">
          <Reveal as="figure" className="portfolio-photo">
            <ProductCarousel />
            <figcaption>OUR SELECTION — 取扱商品の一例</figcaption>
          </Reveal>
          <div className="portfolio-list">
            {productCategories.map((c, i) => (
              <div key={c.english}>
                <span>0{i + 1}</span>
                <h3>{c.english}</h3>
                <p>{c.japanese}</p>
              </div>
            ))}
            <p className="products__note">
              取扱商品・在庫状況は時期により異なります。ご希望の銘柄・数量をお知らせください。
            </p>
            <Link className="text-link" to="/contact">
              商品・仕入れのご相談 <span>↗</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
